import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { watchRequests } from '@/lib/requestActivity';

export function RequestProgress() {
    const [visible, setVisible] = useState(false);
    const [introducing, setIntroducing] = useState(() => !!document.getElementById('pout-startup'));
    useEffect(() => watchRequests(setVisible), []);
    useEffect(() => {
        const finished = () => setIntroducing(false);
        window.addEventListener('pout-startup-finished', finished);
        if (!document.getElementById('pout-startup')) finished();
        return () => window.removeEventListener('pout-startup-finished', finished);
    }, []);
    return visible && !introducing ? createPortal(
        <div role="status" aria-live="polite" style={{position:'fixed', top:'max(12px, env(safe-area-inset-top))', left:'50%', transform:'translateX(-50%)', zIndex:2147483000, pointerEvents:'none', background:'#101a36', color:'#fff', border:'1px solid #bf9f56', borderRadius:999, padding:'10px 18px', display:'flex', alignItems:'center', gap:10, boxShadow:'0 4px 16px #0003'}}>
            <span aria-hidden="true" className="animate-spin motion-reduce:animate-none" style={{width:16,height:16,border:'2px solid #ffffff55',borderTopColor:'#bf9f56',borderRadius:'50%'}} />
            Working…
        </div>, document.body
    ) : null;
}
